/* eslint-disable max-len */
import utils from '../utils';
import PianoInstrument from '../uTheory.Notation/pianoInstrument';
import KeySignature from '../uTheory.Notation/keySignature';

let player;

export default class KeySigPlayer {
  player: PianoInstrument;

  constructor() {
    player = player || new PianoInstrument();
    this.player = player;
  }

  playAnswer(keySig: KeySignature, transpositionHalfSteps = 0) {
    if (!(keySig instanceof KeySignature)) {
      throw new Error('KeySigPlayer.playAnswer(keySig) requires a key signature object.');
    }
    const notes = keySig.getScale();
    for (let i = 1; i <= 7; i++) {
      notes[i - 7] = notes[i].getNoteAt('-P8');
    }
    for (let i = 2; i <= 8; i++) {
      notes[i + 7] = notes[i].getNoteAt('P8');
    }

    const orders = {
      1: [1, 2, 3, 4, 5, 6, 7, 8, 7, 6, 5, 4, 3, 2, 1],
      2: [8, 7, 6, 5, 4, 3, 2, 1, 2, 3, 4, 5, 6, 7, 8],
      3: [1, 3, 5, 8, 7, 5, 4, 2, 1],
      4: [1, 3, 2, 4, 3, 5, 4, 6, 5, 7, 6, 8, 7, 9, 1],
      5: [
        8, 6, 4, 2, 7, 5, 3, 1, 6, 4, 2, 0, 5, 3, 1, -1, 4, 2, -1, -3, 3, 1, -1, -3, 2, 0, -2, -4,
        1, -2, -4, -6,
      ],
      6: [8, 7, 6, 7, 6, 5, 6, 5, 4, 5, 4, 3, 4, 3, 2, 3, 2, 1, 2, 1, 2, 1],
      7: [1, 4, 2, 5, 3, 6, 4, 7, 5, 8, 6, 9, 7, 10, 1],
      8: [
        8, 3, 5, 8, 7, 2, 4, 7, 6, 1, 3, 6, 5, 0, 2, 5, 4, -1, 1, 4, 3, -2, 0, 3, 2, -3, -1, 2, 1,
        -4, -2, 1, -6,
      ],
      9: [1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 1],
      10: [8, 8, 7, 7, 6, 6, 5, 5, 4, 4, 3, 3, 2, 2, 1, 1],
      11: [1, 2, 3, 4, 5, 6, 7, 8],
      12: [8, 7, 6, 5, 4, 3, 2, 1],
      13: [8, 5, 3, 1, 2, 4, 5, 7, 8],
      14: [1, 8, 2, 7, 3, 8, 4, 9, 10, 9, 8, 7, 6, 5, 8],
    };
    const order = Math.floor(Math.random() * 14) + 1;
    const playArray = orders[order];
    for (let i = 0; i < playArray.length; i++) {
      const midinumber = notes[playArray[i]].getMidiNumber() + transpositionHalfSteps;
      const startTime = i / (playArray.length * 0.7);
      //        var stopTime = 4/15 + i*(1/15);
      const stopTime = 2.5;
      const velocityCoefficient = 6 / playArray.length;
      //        if(i==8) stopTime = 2.5;
      const velocity =
        i < 0.66 * playArray.length
          ? (0.33 + i / playArray.length) * velocityCoefficient
          : (0.66 + (playArray.length - i) / playArray.length) * velocityCoefficient;

      this.player.play(midinumber, { startTime, stopTime, velocity });
    }
  }

  playWrongAnswer() {
    const order = [1, 2, 3];
    utils.shuffle(order);
    for (let j = 0; j < 3; j++) {
      const y = order[j];
      for (let i = 0; i < 7; i++) {
        const midi = Math.floor(Math.random() * 12) + 30 + 10 * y;
        this.player.play(midi, {
          startTime: j * 0.45 + 0.005,
          stopTime: 1.5,
          velocity: 0.07 + j / 17,
        });
      }
    }
  }
}
